import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {StandingOrderService} from 'app/blocks/service/api/standing-order.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IStandingOrder} from 'app/blocks/model/standing-order.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {StandingOrder} from 'app/blocks/model/standing-order.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class StandingOrderResource extends AbstractEntityResource<IStandingOrder> {
    constructor(standingOrderService: StandingOrderService, router: Router) {
        super(
            Resource.STANDING_ORDERS,
            standingOrderService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.STANDING_ORDERS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.STANDING_ORDERS),
            (entity?) => new StandingOrder(entity),
            (entity) => entity.id,
            'file_copy'
        );
    }
}
